import { CONTACT } from "../../lib/content";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-[var(--line)] bg-[var(--surface)] overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-16 pb-8">
      <div className="grid md:grid-cols-3 gap-10">
        <Logo testId="footer-logo" className="h-20" />
        <div className="font-mono text-sm space-y-2 text-[var(--ink)]">
          <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="block hover:text-[var(--cyan)]">{CONTACT.email}</a>
          <a data-testid="footer-phone" href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="block hover:text-[var(--cyan)]">{CONTACT.phone}</a>
        </div>
        <div className="font-mono text-sm space-y-2 text-[var(--ink)] md:text-right">
          <p data-testid="footer-ico">IČO: {CONTACT.ico}</p>
          <p className="flex md:justify-end items-center gap-2"><span className="w-2 h-2 rounded-full bg-emerald-500 blink" /> Přijímáme poptávky</p>
        </div>
      </div>
      <p aria-hidden="true" className="mt-16 font-display font-extrabold uppercase text-outline opacity-50 leading-none text-[15vw] whitespace-nowrap select-none">Jen jedno slovo</p>
      <p className="mt-6 font-mono text-xs text-[var(--muted)]">© {new Date().getFullYear()} Jen Jedno Slovo · Catering</p>
    </div>
  </footer>
);
